import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-requesttype-dropdown',
  templateUrl: './RequestTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => RequestTypeDropdownComponent)}]
})
export class RequestTypeDropdownComponent extends BaseDropdownComponent {

    
    public requestTypes: ent.RequestType[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getRequestTypes().subscribe(x=> this.onGetRequestTypesDone(x));
    }
    
    onGetRequestTypesDone(items: ent.RequestType[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }
    
}